module.exports = __webpack_public_path__ + "img/woman_face.b57d505a.png";